import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { useCallback, useEffect, useRef, useState } from "react";
import { cn } from "../../utils";
import { ChevronArrow, CollapseChevron } from "../icons";
import { AddressView } from "../parameters";
import CreditAccountCard from "./CreditAccountCard";
import { statsSelector, useOptimistReportSelector, visibleTracksSelector, } from "./state";
import { TrackStats } from "./TrackStats";
import { usePanelCollapse } from "./usePanelCollapse";
const CreditManagerCard = props => {
    const { executionId, result: results } = props;
    const { accounts, address, name, underlying, hasFailedAccounts: hasErrors, } = results;
    const tracks = useOptimistReportSelector(state => visibleTracksSelector(state));
    const stats = useOptimistReportSelector(state => statsSelector(state, address));
    const maxDiscovered = Object.values(stats).reduce((acc, cur) => Math.max(acc, cur.discovered), 0);
    const { collapseProps, toggleProps, collapsed } = usePanelCollapse(address);
    return (_jsxs("div", { id: address.toLowerCase(), className: clsx("border border-gray-50 rounded-xl mt-4 py-4", {
            "bg-red-950": hasErrors,
        }), children: [_jsx("div", { ...toggleProps, children: _jsxs("div", { className: "flex flex-row items-center justify-between mx-4", children: [_jsxs("div", { className: "flex-1 flex flex-col gap-2 mr-4 overflow-hidden", children: [_jsxs("div", { className: "flex flex-row items-center justify-between shrink-0", children: [_jsx("h2", { children: name }), _jsx(AddressView, { compact: true, address: address, className: "border border-1 border-gray-50 p-1 text-sm rounded-md opacity-70" })] }), _jsx(TracksBar, { tracks: tracks, maxDiscovered: maxDiscovered, stats: stats })] }), _jsx(CollapseChevron, { className: "fill-white", collapsed: collapsed })] }) }), _jsx("div", { ...collapseProps, className: "px-2", children: accounts.map(r => (_jsx(CreditAccountCard, { whitelisted: r.whitelisted, underlying: underlying, executionId: executionId, creditManager: address, results: r }, r.account))) })] }));
};
const TracksBar = props => {
    const { tracks, stats, maxDiscovered } = props;
    const [canScroll, setCanScroll] = useState({
        left: false,
        right: false,
        scrollable: false,
    });
    const scrollRef = useRef(null);
    const checkScroll = useCallback(() => {
        const el = scrollRef.current;
        if (el) {
            setCanScroll({
                left: el.scrollLeft > 0,
                right: Math.abs(el.scrollWidth - el.clientWidth - el.scrollLeft) > 1,
                scrollable: el.scrollWidth > el.clientWidth,
            });
        }
    }, []);
    useEffect(() => {
        scrollRef.current?.scrollTo({ left: 0, behavior: "instant" });
        checkScroll();
    }, [checkScroll]);
    return (_jsxs("div", { className: "flex flex-row items-center gap-2 overflow-hidden", children: [_jsx("button", { className: cn("p-1 hover:bg-gray-800 rounded-full disabled:opacity-50", { hidden: !canScroll.scrollable }), onClick: e => {
                    scrollRef.current?.scrollBy(-150, 0);
                    e.stopPropagation();
                }, disabled: !canScroll.left, children: _jsx(ChevronArrow, { direction: "left", className: "fill-white" }) }), _jsx("div", { className: "flex-1 flex flex-row items-center gap-2 overflow-x-hidden", ref: scrollRef, onScroll: checkScroll, children: tracks.map(t => (_jsx(TrackStats, { maxDiscovered: maxDiscovered, name: t.name, className: "min-w-[150px] shrink-0 justify-between text-xs border rounded-md p-1", ...stats[t.id] }, t.id))) }), _jsx("button", { className: cn("p-1 hover:bg-gray-800 rounded-full disabled:opacity-50", { hidden: !canScroll.scrollable }), onClick: e => {
                    scrollRef.current?.scrollBy(150, 0);
                    e.stopPropagation();
                }, disabled: !canScroll.right, children: _jsx(ChevronArrow, { className: "fill-white", direction: "right" }) })] }));
};
export default CreditManagerCard;
